export default {
  /* ---------------- ↓类型判断↓ ---------------- */
  // 抄自ExtJs
  isArray: ('isArray' in Array) ? Array.isArray : function (value) {
    return Object.prototype.toString.call(value) === '[object Array]'
  },
  isDate: function (obj) {
    return Object.prototype.toString.call(obj) === '[object Date]'
  },
  isNumber: function (value) {
    return typeof value === 'number' && isFinite(value)
  },
  isBoolean: function (value) {
    return typeof value === 'boolean'
  },
  isObject: (Object.prototype.toString(null) === '[object Object]')
  ? function (value) {
    // check ownerDocument here as well to exclude DOM nodes
    return value != null && Object.prototype.toString.call(value) === '[object Object]' && value.ownerDocument === undefined
  }
  : function (value) {
    return Object.prototype.toString.call(value) === '[object Object]'
  },
  isFunction:
  // Safari 3.x and 4.x returns 'function' for typeof <NodeList>, hence we need to fall back to using
  // Object.prototype.toString (slower)
  (typeof document !== 'undefined' && typeof document.getElementsByTagName('body') === 'function') ? function (value) {
    return !!value && Object.prototype.toString(value) === '[object Function]'
  } : function (value) {
    return !!value && typeof value === 'function'
  },
  /* ---------------- ↑类型判断↑ ---------------- */

  /*
   * 判空
   * @param {Object} value 目标数据
   * @param {Boolean} [allowEmptyString] 是否允许空串
   * 以下值认为是空：
   * null
   * undefined
   * []
   * {} (allowEmptyObject===false)
   * '' (allowEmptyString===false)
   */
  isEmpty: function (value, allowEmptyString, allowEmptyObject) {
    return (value == null) || (!allowEmptyString ? value === '' : false) || (this.isArray(value) && value.length === 0) || (this.isArray(value) && value.length === 0) || (!allowEmptyObject ? (this.isObject(value) && this.length(value) === 0) : false)
  },

  /*
   * 克隆
   */
  clone: function (obj, override) {
    if (obj === null || !this.isObject(obj)) {
      console.error('调用克隆方法，传入参数非Object类型')
      return obj
    }
    var result = {}
    for (var key in obj) {
      if (override !== null && this.isObject(override) && override.hasOwnProperty(key)) {
        result[key] = override[key]
      } else {
        result[key] = obj[key]
      }
    }
    return result
  },

  /*
   * 克隆到
   */
  cloneTo: function (source, target) {
    if (source === null || !this.isObject(source) || target === null || !this.isObject(target)) {
      console.error('调用克隆方法，传入参数非Object类型')
      return target
    }
    for (var key in source) {
      target[key] = source[key]
    }
    return target
  },

  /*
   * 获取对象内容项个数
   */
  length: function (obj) {
    var counter = 0
    for (var key in obj) {
      // 排除VUE内置属性
      if (key === '__ob__' || (!key && key.indexOf('get ') === 0) || (!key && key.indexOf('set ') === 0)) {
        continue
      }
      counter++
    }
    return counter
  },

  toQueryObjects: function (name, value, recursive) {
    var vm = this
    var objects = []
    var i
    var ln
    if (vm.isArray(value)) {
      for (i = 0, ln = value.length; i < ln; i++) {
        if (recursive) {
          objects = objects.concat(vm.toQueryObjects(name + '[' + i + ']', value[i], true))
        } else {
          objects.push({
            name: name,
            value: value[i]
          })
        }
      }
    } else if (this.isObject(value)) {
      for (i in value) {
        if (value.hasOwnProperty(i)) {
          if (recursive) {
            objects = objects.concat(vm.toQueryObjects(name + '[' + i + ']', value[i], true))
          } else {
            objects.push({
              name: name,
              value: value[i]
            })
          }
        }
      }
    } else {
      objects.push({
        name: name,
        value: value
      })
    }
    return objects
  },
  toQueryString: function (object, recursive) {
    var vm = this
    var paramObjects = []
    var params = []
    var i
    var j
    var ln
    var paramObject
    var value
    for (i in object) {
      if (object.hasOwnProperty(i)) {
        paramObjects = paramObjects.concat(vm.toQueryObjects(i, object[i], recursive))
      }
    }
    for (j = 0, ln = paramObjects.length; j < ln; j++) {
      paramObject = paramObjects[j]
      value = paramObject.value
      if (vm.isEmpty(value)) {
        value = ''
      } else if (vm.isDate(value)) {
        value = vm.$baize.formatDateToString(value)
      }
      params.push(encodeURIComponent(paramObject.name) + '=' + encodeURIComponent(String(value)))
    }
    return params.join('&')
  },
  getCombo: function (http, urls, params, callBack) {
    if (!urls) {
      urls = 'rest/sys/combo/findCombo'
    }
    http.get(urls, {params: params}).then(response => {
      // 更新数据
      callBack(response.body)
    })
  }
}



// WEBPACK FOOTER //
// ./src/baize/src/BasicUtil.js